import React from 'react';
import { useQualificationStructureUrl } from '../routing';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const ViewQualificationStructureComparisonBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { getListUrl } = useQualificationStructureUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Qualification Structure" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default ViewQualificationStructureComparisonBreadcrumbs;
